import { useCallback, useEffect, useState } from "react";

import { GoogleMap, Marker } from "@react-google-maps/api";
import { useAppSelector } from "../../../../../../app/redux/hooks";
const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultCenter = {
  lat: 9.979733038868975,
  lng: 76.29654182626405,
};

export const GoogleMapSelector = ({
  setSelectedLocation,
  setSelectedActualAddress,
  modalType,
  selectedLocationOnEdit,
  selectedLocation,
}: any) => {
  const [currentLocation, setCurrentLocation] = useState<
    google.maps.LatLngLiteral | undefined
  >(undefined);
  const location = useAppSelector((state) => state.locationState?.locationGot);

  const onMapClick = useCallback((event: google.maps.MapMouseEvent) => {
    if (event.latLng) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      setCurrentLocation({ lat, lng });
      setSelectedLocation({ lat, lng });
      getLocationName(lat, lng);
    }
  }, []);

  useEffect(() => {
    setCurrentLocation(selectedLocation);
  }, [selectedLocation]);
  const fetchLocation = async () => {
    if (modalType === "edit" && selectedLocationOnEdit) {
      // Set the current location to the selected location in edit mode
      setCurrentLocation(selectedLocationOnEdit);
      await getLocationName(
        selectedLocationOnEdit.lat,
        selectedLocationOnEdit.lng
      );
    } else if (modalType === "add") {
      if (location?.latitude && location?.longitude) {
        const lat = location.latitude;
        const lng = location.longitude;
        const location1 = { lat, lng };
        setCurrentLocation(location1);
        setSelectedLocation(location1);
        await getLocationName(lat, lng);
      } else {
        setCurrentLocation(defaultCenter);
        setCurrentLocation(defaultCenter);
        setSelectedLocation(defaultCenter);
        await getLocationName(defaultCenter.lat, defaultCenter.lng);
      }
      // Fetch the user's current location
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(
      //     async (position) => {
      //       const lat = position.coords.latitude;
      //       const lng = position.coords.longitude;
      //       const location = { lat, lng };
      //       setCurrentLocation(location);
      //       setSelectedLocation(location);
      //       await getLocationName(lat, lng);
      //     },
      //     async (error) => {
      //       console.error("Error fetching location:", error);
      //       // Fallback to default center if permission is denied or an error occurs
      //       setCurrentLocation(defaultCenter);
      //       setCurrentLocation(defaultCenter);
      //       setSelectedLocation(defaultCenter);
      //       await getLocationName(defaultCenter.lat, defaultCenter.lng);
      //     }
      //   );
      // } else {
      //   console.error("Geolocation is not supported by this browser.");
      //   setCurrentLocation(defaultCenter);
      //   await getLocationName(defaultCenter.lat, defaultCenter.lng);
      // }
    }
  };

  useEffect(() => {
    fetchLocation();
  }, [modalType, selectedLocationOnEdit]);

  // Function to reverse geocode latitude/longitude into a location name
  const getLocationName = async (lat: number, lng: number) => {
    if (!window.google) {
      console.error("Google Maps API is not available.");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latLng = { lat, lng };

    geocoder.geocode({ location: latLng }, (results: any, status) => {
      if (status === "OK") {
        if (results[0]) {
          setSelectedActualAddress(results[0]?.formatted_address);
          console.log("Address found.");
        } else {
          console.log("No address found.");
          // dispatch(setUserLocation({ display_name: "No address found" }));
        }
      } else {
        console.error("Geocoder failed due to:", status);
        // dispatch(setUserLocation({ display_name: "Unable to fetch address." }));
      }
    });
  };
  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={currentLocation}
      zoom={14}
      onClick={onMapClick}
      options={{
        disableDefaultUI: true,
        zoomControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        mapTypeId: "roadmap",
      }}
    >
      {currentLocation && <Marker position={currentLocation} />}
    </GoogleMap>
  );
};
